import React, { useEffect, useState } from 'react';

const VariableMenuContainer = (props) => {

  const { pageRef, blockEditing, currentBlock, headerUUID, footerUUID, currentEditor } = props;

  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    let timer = null;
    const onScroll = (el) => {
      setScroll(true);
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        setScroll(false);
      }, 200);
    }
    const onScrollEnd = (el) => {
      setScroll(false);
    }
    if (blockEditing && currentBlock && (currentBlock !== headerUUID || currentBlock !== footerUUID)) {
      let targetDOM = pageRef.current.querySelector('[id=complex-page-wrapper]').childNodes[0];
      console.log({ targetDOM });
      targetDOM.addEventListener('scroll', onScroll);
      targetDOM.addEventListener('scrollend', onScrollEnd);

      return () => {
        targetDOM.removeEventListener('scroll', onScroll);
        targetDOM.removeEventListener('scrollend', onScrollEnd);
      }
    }
  }, [blockEditing, currentBlock, headerUUID, footerUUID]);

  let targetDOM = pageRef.current.querySelector('[id=complex-page-wrapper]').childNodes[0];

  return (
    <div
      id={`variable-menu-container`}
      className="popup-variableList-container"
      style={{
        display: scroll ? 'none' : 'block',
        position: 'absolute',
        top: pageRef.current.offsetTop + targetDOM.offsetTop + ((currentEditor?.getBoundingClientRect()?.top - targetDOM.getBoundingClientRect().top)),
        left: 30 + ((currentEditor?.getBoundingClientRect()?.left - targetDOM.getBoundingClientRect().left)),
        zIndex: 3001,
      }}
    />
  );
}

export default VariableMenuContainer;